import { Avatar, Form, Select, Space, Typography } from 'antd';
import { INFINITE_PAGE_SIZE } from 'constants/pagination';
import { FC, memo, useEffect, useState } from 'react';
import { fetchDoctors } from 'services/api/doctors';
import { DoctorListRow } from 'types/api/doctors';

import { getFileUrl } from 'utils/file';
import { pickLocale } from 'utils/pickLocale';

const DoctorsSelect: FC = () => {
  const [doctors, setDoctors] = useState<DoctorListRow[]>([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetchDoctors({
          page: 1,
          limit: INFINITE_PAGE_SIZE
        });

        if (!cancelled) setDoctors(res.results);
      } catch {
        // swallow — empty picker on failure
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Form.Item name="doctors" label="Doctors">
      <Select mode="multiple">
        {doctors.map(item => (
          <Select.Option key={`doctor-item-${item.id}`} value={item.id}>
            <Space align="center" size={8}>
              <Avatar src={getFileUrl(item.avatar)} size={20} />
              <Typography.Text>
                {pickLocale(item.first_name, 'en')}{' '}
                {pickLocale(item.last_name, 'en')}
              </Typography.Text>
            </Space>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default memo(DoctorsSelect);
